import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { Separation, TerminationAppeal } from 'src/app/shared/models/separation';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { SeparationService } from 'src/app/shared/services/separation.service';
@Component({
  selector: 'app-termination-appeal',
  templateUrl: './termination-appeal.component.html',
  styleUrls: ['./termination-appeal.component.scss']
})
export class TerminationAppealComponent implements OnInit {
  @Input() separation: Separation;
  @Input() context: Context;
  @Input() separationId: number;
  public terminationAppeal: TerminationAppeal;
  public terminationAppealForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public appeal: any;
  public appealSatus: string;

  constructor(
    private separationService: SeparationService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private authService: AuthService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.context = this.authService.getContextData();
    this.setAppealForm(this.terminationAppeal);
    this.getTerminationAppeal();
    this.separationService.getAppealStatus().subscribe(appealSatus=> (this.appealSatus = appealSatus));
  }

  public getTerminationAppeal() {
    if (!this.separationId) return;
    this.separationService.getTerminationAppeal(this.separationId).subscribe(terminationAppeal => {
      if (terminationAppeal?.length) {
        this.appeal = terminationAppeal[0];
        this.terminationAppealForm.patchValue({
          id:this.appeal.id,
          appealReason: this.appeal.appealReason,
          reviewedAt: this.appeal.reviewedAt ? this.datePipe.transform(this.appeal.reviewedAt, 'yyyy-MM-dd') : null,
          terminationStatus: this.appeal.terminationStatus,
          comment: this.appeal.comment,
        });
      }
    });
  }

  public setAppealForm(terminationAppeal?: TerminationAppeal) {
    if (!terminationAppeal)
      terminationAppeal = {
        id: null,
        appealReason: null,
        reviewedAt: null,
        comment: null,
        terminationStatus: 'PENDING',
        employeeId: null,
        separationId: this.separationId,
        reviewedBy: this.context?.employeeId,
        reviewerName: null,
      } as TerminationAppeal;
    this.terminationAppealForm = this.fb.group({
      id: this.fb.control(terminationAppeal.id, []),
      appealReason: this.fb.control(terminationAppeal.appealReason, [Validators.required]),
      reviewedAt: this.fb.control(this.datePipe.transform(new Date(), 'yyyy-MM-dd')),
      comment: this.fb.control(terminationAppeal.comment, []),
      terminationStatus: this.fb.control(terminationAppeal.terminationStatus, []),
      employeeId: this.fb.control(terminationAppeal.employeeId, []),
      separationId: this.fb.control(terminationAppeal.separationId, [Validators.required]),
      reviewedBy: this.fb.control(terminationAppeal.reviewedBy, [Validators.required]),
      reviewerName: this.fb.control(terminationAppeal.reviewerName, []),
    });
    this.terminationAppealForm.valueChanges.subscribe(value => this.modified = true);
  }

  get s() {
    return this.terminationAppealForm.controls;
  }

  public saveTerminationAppeal() {
    if (this.terminationAppealForm.valid) {
      const terminationAppeal = this.terminationAppealForm.value as TerminationAppeal;
      if(this.appeal?.id){
        this.separationService.updateTerminationAppeal(this.appeal.id, terminationAppeal).subscribe({
          next:(response: Message)=>{
            if(!response.failed){
              this.commonService.setToastr(200, response.text);
            }else{
              this.commonService.setToastr(500, `Unable to complete the action.Please try again`)
            }
          }
        })
      }else{
        this.separationService.createTerminationAppeal(terminationAppeal).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.commonService.setToastr(200, `Termination Appeal has been created successfully!`);
              this.getTerminationAppeal();
            } else {
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } 
    }
  }
}




